import React from 'react';
import {Status} from '@googlemaps/react-wrapper';

const MapStatus = (status) => {
    if (status === Status.LOADING) return <div>Loading...</div>;
    if (status === Status.FAILURE) return <div className="alert alert-danger">Google Maps error</div>;
    return null;
};

export default MapStatus;
